import React from 'react';
import {Divider} from "antd";

function SummaryCard({topSummary = [], bottomSummary = []}) {
    return (
        <div className={'ch-report-summary-card'}>
            <dl className={'ch-report-summary-card-row'}>
                {topSummary.map((stat, index) => (
                    <div key={index} className="ch-report-summary-card-detail">
                        <dt>{stat.label}</dt>
                        <dd className="ch-report-summary-card-number">{stat.value}</dd>
                    </div>
                ))}
            </dl>
            <Divider style={{margin: '6px 0'}} />
            <dl className={'ch-report-summary-card-row'}>
                {bottomSummary.map((stat, index) => (
                    <div key={index} className="ch-report-summary-card-detail">
                        <dt>{stat.label}</dt>
                        <dd className="ch-report-summary-card-number" style={{fontSize: "24px"}}>{stat.value}</dd>
                    </div>
                ))}
            </dl>
        </div>
    );
}

export default SummaryCard;